import React from "react";
import { Box, Stack, Typography } from "@mui/material";

interface BarItem {
  label: string;
  value: number;
  color?: string;
}

export function MockBarChart({
  data,
  max = 100,
}: {
  data: BarItem[];
  max?: number;
}) {
  return (
    <Stack spacing={1.25}>
      {data.map((item) => (
        <Box key={item.label}>
          <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
            <Typography sx={{ fontSize: 13, color: "#33495C", fontWeight: 600 }}>
              {item.label}
            </Typography>
            <Typography sx={{ fontSize: 13, color: "#66788A" }}>{item.value}%</Typography>
          </Stack>
          <Box sx={{ height: 10, borderRadius: 99, bgcolor: "#EEF2F4", overflow: "hidden" }}>
            <Box
              sx={{
                width: `${Math.min((item.value / max) * 100, 100)}%`,
                height: "100%",
                borderRadius: 99,
                bgcolor: item.color || "#116B43",
              }}
            />
          </Box>
        </Box>
      ))}
    </Stack>
  );
}

export function MockTrendChart({
  points,
}: {
  points: Array<number>;
}) {
  return (
    <Box
      sx={{
        height: 220,
        borderRadius: "10px",
        bgcolor: "#F8FAFB",
        border: "1px dashed #DCE4E8",
        p: 2,
        display: "flex",
        alignItems: "flex-end",
        gap: 1,
      }}
    >
      {points.map((point, i) => (
        <Box
          key={i}
          sx={{
            flex: 1,
            borderRadius: "8px 8px 0 0",
            bgcolor: i === points.length - 1 ? "#116B43" : "#8FAECC",
            height: `${point}%`,
            minHeight: 18,
          }}
        />
      ))}
    </Box>
  );
}
